import * as lan from '../common/script/common_lan.js';


export default function Wrap(props){
	const {...rest} = props
	return (
		<div className="wrap" {...rest} id="wrap"/>
	)
}